import { isPlatformServer } from '@angular/common';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BusinessRegionResponse, OCC_ENDPOINTS } from '@city/const';
import { GeoPoint, HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable, identity } from 'rxjs';
import { timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OccBusinessRegionService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    @Inject(PLATFORM_ID) private platform: any,
  ) {}

  loadBusinessRegion({ latitude, longitude }: GeoPoint): Observable<BusinessRegionResponse> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.defineBaseStore);

    return this.http
      .post<BusinessRegionResponse>(
        url,
        { lat: latitude, lon: longitude },
        {
          context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.defineBaseStore),
        },
      )
      .pipe(isPlatformServer(this.platform) ? timeout(500) : identity);
  }
}
